import type SvgIcon from 'LuxKit/SvgIcon'
import type { SvgIconProps } from 'LuxKit/SvgIcon'
import ResponsiveLuxuryEscapesLogo from 'components/App/Header/Logo/logos/ResponsiveLuxuryEscapesLogo'
import SolidStarIcon from 'LuxKit/Icons/solid/SolidStarIcon'
import LineSearchIcon from 'LuxKit/Icons/line/LineSearchIcon'
import LineMountainsSunIcon from 'LuxKit/Icons/line/LineMountainsSunIcon'
import LineUserPlusIcon from 'LuxKit/Icons/line/LineUserPlusIcon'
import LineGiftIcon from 'LuxKit/Icons/line/LineGiftIcon'
import LineTicketIcon from 'LuxKit/Icons/line/LineTicketIcon'
import LineTagAltIcon from 'LuxKit/Icons/line/LineTagAltIcon'
import LineBoltAltIcon from 'LuxKit/Icons/line/LineBoltAltIcon'
import LineBullseyeIcon from 'LuxKit/Icons/line/LineBullseyeIcon'
import LineUserIcon from 'LuxKit/Icons/line/LineUserIcon'
import LineGlobeIcon from 'LuxKit/Icons/line/LineGlobeIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineHotAirBalloonIcon from 'LuxKit/Icons/line/LineHotAirBalloonIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import LineUltraLuxDiamondIcon from 'LuxKit/Icons/line/LineUltraLuxDiamondIcon'
import LineShipIcon from 'LuxKit/Icons/line/LineShipIcon'
import LineCompassIcon from 'LuxKit/Icons/line/LineCompassIcon'
import LineIslandIcon from 'LuxKit/Icons/line/LineIslandIcon'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import LineStopwatchIcon from 'LuxKit/Icons/line/LineStopwatchIcon'
import LineCarIcon from 'LuxKit/Icons/line/LineCarIcon'
import LineVillaIcon from 'LuxKit/Icons/line/LineVillaIcon'
import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import LineCommentsIcon from 'LuxKit/Icons/line/LineCommentsIcon'
import SolidPlusIcon from 'LuxKit/Icons/solid/SolidPlusIcon'
import SolidSparklesIcon from 'LuxKit/Icons/solid/SolidSparklesIcon'
import LineShopIcon from 'LuxKit/Icons/line/LineShopIcon'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'
import LineNewspaperIcon from 'LuxKit/Icons/line/LineNewspaperIcon'
import LineShieldIcon from 'LuxKit/Icons/line/LineShieldIcon'
import LineUserArrowsIcon from 'LuxKit/Icons/line/LineUserArrowsIcon'
import LineBriefcaseIcon from 'LuxKit/Icons/line/LineBriefcaseIcon'
import LineGolfIcon from 'LuxKit/Icons/line/LineGolfIcon'
import LineUsersMultiIcon from 'LuxKit/Icons/line/LineUsersMultiIcon'
import LineCalendarAltIcon from 'LuxKit/Icons/line/LineCalendarAltIcon'
import LineCalendarHeartIcon from 'LuxKit/Icons/line/LineCalendarHeartIcon'
import LineStoreIcon from 'LuxKit/Icons/line/LineStoreIcon'

function ResponsiveLuxuryEscapesIconLogo(props: SvgIconProps) {
  const { size, colour, fill = 'currentColor', ...rest } = props

  return <ResponsiveLuxuryEscapesLogo
    {...rest}
    fill={fill}
    width={24}
    height={24}
    mobileVariant="icon"
    tabletVariant="icon"
    desktopVariant="icon"
    extraLargeDesktopVariant="icon"
  />
}

const iconMap: Record<string, typeof SvgIcon> = {
  star: SolidStarIcon,
  search: LineSearchIcon,
  'mountains-sun': LineMountainsSunIcon,
  gift: LineGiftIcon,
  'user-plus': LineUserPlusIcon,
  'plane-departure': LinePlaneDepartureIcon,
  ticket: LineTicketIcon,
  'tag-alt': LineTagAltIcon,
  'bolt-alt': LineBoltAltIcon,
  bulleyse: LineBullseyeIcon,
  user: LineUserIcon,
  globe: LineGlobeIcon,
  'line-star': LineStarIcon,
  'hot-air-balloon': LineHotAirBalloonIcon,
  'ultra-lux-diamond': LineUltraLuxDiamondIcon,
  island: LineIslandIcon,
  ship: LineShipIcon,
  compass: LineCompassIcon,
  bed: LineBedIcon,
  stopwatch: LineStopwatchIcon,
  car: LineCarIcon,
  'home-alt': LineVillaIcon,
  heart: LineHeartIcon,
  comments: LineCommentsIcon,
  plus: SolidPlusIcon,
  shop: LineShopIcon,
  sparkles: SolidSparklesIcon,
  usd: LineUsdCircleIcon,
  magazine: LineNewspaperIcon,
  shield: LineShieldIcon,
  'user-arrows': LineUserArrowsIcon,
  briefcase: LineBriefcaseIcon,
  golf: LineGolfIcon,
  'users-multi': LineUsersMultiIcon,
  calendar: LineCalendarAltIcon,
  'calendar-heart': LineCalendarHeartIcon,
  store: LineStoreIcon,
  'le-logo': ResponsiveLuxuryEscapesIconLogo,
}

export const getNavigationMenuIcon = (name: string) => iconMap[name]
